import { render, staticRenderFns } from "./candidate-results.vue?vue&type=template&id=5a5d01d4&"
import script from "./candidate-results.vue?vue&type=script&lang=js&"
export * from "./candidate-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports